import { IconButton, Tooltip } from "@material-ui/core";
import { IconButtonProps } from "@material-ui/core/IconButton";
import { createStyles, WithStyles, withStyles } from "@material-ui/core/styles";
import classnames from "classnames";
import * as React from "react";

import { TimesIcon } from "../../assets/icons";
import { RelodeTheme } from "../styles";
import { MergeTypes } from "../utils";

const styles = (theme: RelodeTheme) =>
    createStyles({
        root: {},
    });

interface InnerDialogCloseIconButton extends WithStyles<typeof styles> {
    className?: string;
    fontSize?: "small" | "inherit" | "default" | "large";
}

type DialogCloseIconButtonProps = MergeTypes<
    InnerDialogCloseIconButton,
    IconButtonProps
>;

export const DialogCloseIconButton = withStyles(styles, {
    name: "DialogCloseIconButton",
})((props: DialogCloseIconButtonProps) => {
    const {
        onClick,
        className: classNameProp,
        classes,
        color = "primary",
        fontSize = "default",
        title = "close",
    } = props;

    const rootClasses = classnames(
        {
            [classes.root]: true,
        },
        classNameProp
    );

    return (
        <Tooltip placement="right" title={title}>
            <IconButton
                onClick={onClick}
                color={color}
                className={rootClasses}
                data-cy="closeDialogButton"
            >
                <TimesIcon fontSize={fontSize} />
            </IconButton>
        </Tooltip>
    );
});
